import React, { useState } from 'react';
import Icon, { LoadingOutlined } from '@ant-design/icons';
import { SearchIcon } from 'icons';
import Modal from 'antd/lib/modal';
import Text from 'antd/lib/typography/Text';
import Notification from 'antd/lib/notification';
import { t } from 'utils/i18n';
import { fetchAnnotationsAsync, saveAnnotationsAsync } from '../../../../actions/annotation-actions';
import { getCVATStore } from '../../../../cvat-store';

export interface Props {
    jobId: number;
}

function TaskEmbeddingControl(props: Props): React.ReactNode {
    const { jobId } = props;
    const [saving, setSaving] = useState(false);
    const [active, setActive] = useState(false);
    const baseURL = window.location.origin;
    const storage = getCVATStore();

    const handleClick = async () => {
        setActive(true);
        await storage.dispatch(
            saveAnnotationsAsync(async () => {
                setSaving(true);
                try {
                    const response = await fetch(`${baseURL}/api/jobs/${jobId}/models`, {
                        method: 'GET',
                    });
                    if (!response.ok) {
                        throw new Error(t('Request failed with status {status}', { status: response.status }));
                    }
                    await storage.dispatch((fetchAnnotationsAsync(true)));
                } catch (error) {
                    console.error('Error:', error);
                    Notification.error({
                        message: t('Error'),
                        description: error.toString(),
                        className: 'cvat-notification-notice-get-issues-error',
                    });
                } finally {
                    setSaving(false);
                    setActive(false);
                }
            }),
        );
    };

    return (
        <>
            <Icon
                className={`cvat-draw-rectangle-control ${active ? 'cvat-active-canvas-control' : 'cvat-disabled-canvas-control'} cvat-embedding-control`}
                component={SearchIcon}
                onClick={handleClick}
                onMouseEnter={() => setActive(true)}
                onMouseLeave={() => setActive(false)}
            />
            <Modal
                className='cvat-saving-job-modal'
                title={t('Saving changes on the server')}
                visible={saving}
                footer={null}
                closable={false}
            >
                <Text>{t('Searching for matching 3D models based on your image. Please wait.')}</Text>
                <LoadingOutlined />
            </Modal>
        </>
    );
}

export default React.memo(TaskEmbeddingControl);
